module.exports = __webpack_public_path__ + "static/media/rev2.7ffee680.png";